import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'

import { MainBodyContainer, Heading } from './styled'

const MainBodyContent = (props) => {
  const { children, headerTitle, accessoriesHeader, breadcrumbs, accessoriesHeaderLeft, priority = '', headerStyle = {} } = props

  const showPriority = () => (
    <React.Fragment>{priority.toLowerCase() === 'urgent' ? <div className='priorityUrgent'>{priority.toUpperCase()}</div> : null}</React.Fragment>
  )

  return (
    <MainBodyContainer>
      {headerTitle !== '' ?
        <Heading style={{ ...headerStyle }}>
          <div className='titleContent'>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className='titleText'>{headerTitle}{showPriority()}</div>
              <div style={{ marginLeft: '1rem' }}>{accessoriesHeaderLeft}</div>
            </div>
            <div>{breadcrumbs}</div>
          </div>
          <div className='accessoriesContent'>{accessoriesHeader}</div>
        </Heading>
        :
        null
      }
      {children}
    </MainBodyContainer>
  )
}

const mapStateToProps = (state) => ({})
const mapDispatchToProps = {}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  connect((state, props) => ({
    history: props.history,
    children: props.children,
    headerTitle: props.headerTitle
  })),
  lifecycle({
    componentDidMount() { },
  })
)

export default enhance(MainBodyContent)